import { render, staticRenderFns } from "./kpsrAction.vue?vue&type=template&id=38fdda9d"
import script from "./kpsrAction.vue?vue&type=script&lang=js"
export * from "./kpsrAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38fdda9d')) {
      api.createRecord('38fdda9d', component.options)
    } else {
      api.reload('38fdda9d', component.options)
    }
    module.hot.accept("./kpsrAction.vue?vue&type=template&id=38fdda9d", function () {
      api.rerender('38fdda9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/action/kpsrAction.vue"
export default component.exports